import {KeyValue} from '@angular/common';

const originalOrder = (a: KeyValue<number, string>, b: KeyValue<number, string>): number => 0;

export {originalOrder};
